import {css} from "@emotion/react";

import {calculateRemSize, p} from "@pg-design/helpers-css-strings";
import {Image} from "@pg-design/image-module";
import {getThemeVariable} from "@pg-design/styles-strings";
import {Text} from "@pg-design/text-module";

import {ConsultantBoxType} from "../types/ConsultantBoxType";
import {getConsultantInfoFromType} from "../utils/get_consultant_info_from_type";

const consultantImg = require("../images/for_you_expert.png");

interface IProps {
    type?: ConsultantBoxType;
}

export const ConsultantBox = (props: IProps) => {
    const consultantInfo = getConsultantInfoFromType(props.type);
    return (
        <div className="consultant-box" css={consultantBox}>
            <Image width="44" height="44" src={consultantImg} alt="zdjęcie konsultanta" />

            <div>
                <Text variant="body_copy_2">{consultantInfo.name}</Text>
                <Text variant="info_txt_2">{consultantInfo.title}</Text>
                {consultantInfo.phone && (
                    <a href={`tel:${consultantInfo.phone.href}`}>
                        <Text variant="info_txt_1" style={{marginTop: calculateRemSize(1)}}>
                            {consultantInfo.phone.label}
                        </Text>
                    </a>
                )}
            </div>
        </div>
    );
};

const consultantBox = css`
    border-radius: ${calculateRemSize(1)};
    border: 1px solid ${getThemeVariable("colors.gray.600")};
    display: flex;
    flex-direction: row;
    gap: ${calculateRemSize(1)};
    align-items: center;
    ${p(1)};
    min-width: 234px;
`;
import {css} from "@emotion/react";

import {calculateRemSize, p} from "@pg-design/helpers-css-strings";
import {Image} from "@pg-design/image-module";
import {getThemeVariable} from "@pg-design/styles-strings";
import {Text} from "@pg-design/text-module";

import {ConsultantBoxType} from "../types/ConsultantBoxType";
import {getConsultantInfoFromType} from "../utils/get_consultant_info_from_type";

const consultantImg = require("../images/for_you_expert.png");

interface IProps {
    type?: ConsultantBoxType;
}

export const ConsultantBox = (props: IProps) => {
    const consultantInfo = getConsultantInfoFromType(props.type);
    return (
        <div className="consultant-box" css={consultantBox}>
            <Image width="44" height="44" src={consultantImg} alt="zdjęcie konsultanta" />

            <div>
                <Text variant="body_copy_2">{consultantInfo.name}</Text>
                <Text variant="info_txt_2">{consultantInfo.title}</Text>
                {consultantInfo.phone && (
                    <a href={`tel:${consultantInfo.phone.href}`}>
                        <Text variant="info_txt_1" style={{marginTop: calculateRemSize(1)}}>
                            {consultantInfo.phone.label}
                        </Text>
                    </a>
                )}
            </div>
        </div>
    );
};

const consultantBox = css`
    border-radius: ${calculateRemSize(1)};
    border: 1px solid ${getThemeVariable("colors.gray.600")};
    display: flex;
    flex-direction: row;
    gap: ${calculateRemSize(1)};
    align-items: center;
    ${p(1)};
    min-width: 234px;
`;
